module.exports = __webpack_public_path__ + "img/PreviousAdmin2.73f406d6.svg";